import type {ApiResourceName} from '../../../api/types';
import type {
  CoreClientFoodTrackerCreateParams,
  CoreClientFoodTrackerDeleteParams,
  CoreClientFoodTrackerReadParams,
  CoreClientFoodTrackerSchemaParams,
  CoreClientFoodTrackerUpdateParams,
} from '../../types/core/methods';
import type {FoodTrackerApiModel} from './types';

import {apiRequest} from '../../../api/utils/apiRequest';
import {EntityStore} from '../../../api/utils/entityStore';

const RESOURCE_NAME: ApiResourceName = 'food_tracker';

type Schema = {
  [key: string]: {
    required: boolean;
    unit: string;
  };
};

class FoodTrackerStore<
  T extends FoodTrackerApiModel = FoodTrackerApiModel,
> extends EntityStore<
  T,
  CoreClientFoodTrackerCreateParams,
  object,
  CoreClientFoodTrackerUpdateParams,
  CoreClientFoodTrackerDeleteParams
> {
  async getSchema(params?: CoreClientFoodTrackerSchemaParams) {
    const response: {_schema: Schema} =
      await apiRequest<CoreClientFoodTrackerSchemaParams>({
        method: 'client.food_tracker.schema',
        params,
      });

    return response._schema;
  }

  async read(params?: CoreClientFoodTrackerReadParams) {
    const response = await apiRequest<CoreClientFoodTrackerReadParams>({
      method: 'client.food_tracker.read',
      params,
    });

    return this._processResult(response, params);
  }
}

export const foodTrackerStore = new FoodTrackerStore(RESOURCE_NAME, {
  create: 'client.food_tracker.create',
  delete: 'client.food_tracker.delete',
  update: 'client.food_tracker.update',
});
